module.exports = __webpack_public_path__ + "static/media/img20.77d5d45b.jpg";